import React from "react";
import "./Training.css";

export default function Training() {
  return (
    <main className="training-container">
      <h1>Training</h1>
      <section id="team">
        <h2>Unser Trainerteam</h2>
        <ul className="trainer-list">
          <li>
            <strong>Martin</strong>
            <br />
            Unser Tauchlehrer
          </li>
          <li>
            <strong>Jacqueline</strong>
            <br />
            Unsere Tauchlehrerin
          </li>
          <li>
            <strong>Wolfgang</strong>
            <br />
            Unser Übungsleiter
          </li>
          <li>
            <strong>Dagmar</strong>
            <br />
            Unsere Übungsleiterin
          </li>
          <li>
            <strong>Hajo</strong>
            <br />
            Unser Übungsleiter
          </li>
          <li>
            <strong>Vanessa</strong>
            <br />
            Unsere Übungsleiterin
          </li>
        </ul>
      </section>

      <section id="konzept">
        <h2>Trainingskonzept</h2>
        <p>
          Das Training besteht bei uns aus Flossenschwimmen / Schnorcheln und
          Tauchen mit der ABC-Ausrüstung (Flossen, Maske, Schnorchel). Im
          regelmäßigen Training wollen wir unsere Technik und Kondition
          verbessern, um mehr Freude am nächsten Tauchgang zu haben oder einfach
          nur aus Spaß an der Bewegung im und unter Wasser. Zu bestimmten
          Anlässen bringen wir eine komplette Tauchausrüstung (Flasche,
          Tarierweste, Atemregler etc.) mit und üben das Tauchen mit dieser
          Ausrüstung.
        </p>
      </section>

      <section id="zeiten">
        <h2>Trainingszeiten</h2>

        <h3>Hallenbadsaison</h3>
        <div class="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Wann?</th>
                <th>Wo?</th>
                <th>Trainingsmöglichkeit</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Dienstag, 20:00 - 21:30 Uhr</td>
                <td>
                  Stadtbad Tiergarten
                  <br />
                  Seydlitzstraße 7, 10557 Berlin
                </td>
                <td>zwei 25m-Bahnen</td>
              </tr>
              <tr>
                <td>Sonntags, 11:00 - 13:00 Uhr</td>
                <td>
                  Kombibad Seestraße
                  <br />
                  Seestraße 80, 13347 Berlin
                </td>
                <td>eine 50m-Bahn (Traglufthalle)</td>
              </tr>
            </tbody>
          </table>
        </div>
        <h3>Freibadsaison</h3>
        <div class="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Wann?</th>
                <th>Wo?</th>
                <th>Trainingsmöglichkeit</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Mittwochs, 20:00 - 21:30 Uhr</td>
                <td>
                  Sommerbad Kreuzberg
                  <br />
                  Prinzenstraße 113-119, 10969 Berlin
                </td>
                <td>Terrassenbecken, tiefer Bereich</td>
              </tr>
              <tr>
                <td>Donnerstags, 19:00 - 20:00 Uhr</td>
                <td>
                  Kombibad Seestraße
                  <br />
                  Seiteneingang Ungarnstraße
                </td>
                <td>
                  Sprungbecken & 25m-Bahn <br></br> (Nr. 5)
                </td>
              </tr>
              <tr>
                <td>Sonntags, 11:00 - 13:00 Uhr</td>
                <td>
                  Kombibad Seestraße
                  <br />
                  Seiteneingang Ungarnstraße
                </td>
                <td>
                  25m-Bahn <br></br> (Nr. 4)
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <p style={{ marginTop: "1rem" }}>
          Wir treffen uns etwa 10 Minuten vor Trainingsbeginn vor dem Eingang
          und gehen gemeinsam ins Schwimmbad. Neue Teilnehmer sind nach
          Anmeldung herzlich willkommen, an einem Schnuppertraining
          teilzunehmen.
        </p>
      </section>

      <section id="schnuppertraining">
        <h2>Schnuppertraining</h2>
        <p>
          Wir bieten Dir die Möglichkeit, uns innerhalb von drei kostenfreien
          Schnuppertrainings unverbindlich kennenzulernen. Neue Teilnehmer
          melden sich bitte vorher über das{" "}
          <a href="/kontakt">Kontaktformular </a>
          oder per E-Mail bei unseren Trainern an. Teile bitte auch mit, ob Du
          eine Leih-ABC-Ausrüstung benötigst.
        </p>
      </section>
    </main>
  );
}
